import {Box} from '@chakra-ui/react';
import {InfiniteData} from '@tanstack/react-query';
import {InfinityScrollButton, ProviderTileList, ProviderTileWithSkeletion} from 'components/shared';
import {FC} from 'react';
import {TranslationKeys} from 'translations';
import {ICustomerAddToFavoritesRequest, ICustomerMyFavoritesResponse, IProvider} from 'types';

interface IProps {
  restaurantData?: InfiniteData<IProvider>;
  isLoadingRestaurants: boolean;
  isDesktop: boolean;
  hasNextPage?: boolean;
  isFetchingNextPage: boolean;
  myFavorite: ICustomerMyFavoritesResponse[];
  onEditFavorites: (data: ICustomerAddToFavoritesRequest) => void;
  t: (term: TranslationKeys) => string;
  fetchNextPage: () => void;
}

export const Restaurants: FC<IProps> = ({
  isDesktop,
  myFavorite,
  onEditFavorites,
  isLoadingRestaurants,
  restaurantData,
  hasNextPage,
  fetchNextPage,
  isFetchingNextPage,
}) => {
  return (
    <>
      <Box flexWrap="wrap" justifyContent="left" pb="30px" px={['15px', '0px']} w="100%">
        <ProviderTileWithSkeletion conditionValue={isLoadingRestaurants}>
          <>
            {restaurantData?.pages?.map((page, index) => {
              const restaurants = page.results;

              return (
                <ProviderTileList
                  key={index}
                  boxProps={{as: 'li', width: '100%'}}
                  myFavorite={myFavorite}
                  onEditFavorite={onEditFavorites}
                  data={restaurants}
                  tileSize={isDesktop ? '320px' : '100%'}
                  isDesktop={isDesktop}
                />
              );
            })}
          </>
        </ProviderTileWithSkeletion>
      </Box>
      {hasNextPage && (
        <InfinityScrollButton
          fetchNextPage={fetchNextPage}
          isFetchingNextPage={isFetchingNextPage}
          providerPageCount={restaurantData?.pages.length}
        />
      )}
    </>
  );
};
